import React from 'react';
import '@expo/match-media';
import { useMediaQuery } from 'react-responsive';
import { View } from 'react-native';
import * as R from 'unitx/ramda';
import { ClearFix, Col, Hidden, Row, ScreenClassProvider, Visible, setConfiguration } from 'react-grid-system';
import { Container } from "./Grid";

const Desktop = ({
  children
}) => {
  const isDesktop = useMediaQuery({
    minWidth: 992
  });
  return isDesktop ? children : null;
};

const Tablet = ({
  children
}) => {
  const isTablet = useMediaQuery({
    minWidth: 768,
    maxWidth: 991
  });
  return isTablet ? children : null;
};

const Mobile = ({
  children
}) => {
  const isMobile = useMediaQuery({
    maxWidth: 767
  });
  return isMobile ? children : null;
};

const Default = ({
  children
}) => {
  const isNotMobile = useMediaQuery({
    minWidth: 768
  });
  return isNotMobile ? children : null;
};

export const MediaQuery = ({
  children
}) => {
  const isDesktop = useMediaQuery({
    minWidth: 992
  });
  const isTablet = useMediaQuery({
    minWidth: 768,
    maxWidth: 991
  });
  const isMobile = useMediaQuery({
    maxWidth: 767
  });
  return children({
    isDesktop,
    isTablet,
    isMobile,
    isDefault: !isDesktop && !isTablet && isMobile
  });
};
export const ScreenMediaQuery = ({
  children,
  desktop,
  tablet,
  mobile,
  style = {}
}) => /*#__PURE__*/React.createElement(View, {
  style: style
}, /*#__PURE__*/React.createElement(MediaQuery, null, matches => /*#__PURE__*/React.createElement(React.Fragment, null, R.cond([// @ts-ignore
[R.always(matches.isDesktop && desktop), desktop], // @ts-ignore
[R.always(matches.isTablet && tablet), tablet], // @ts-ignore
[R.always(matches.isMobile && mobile), mobile], // @ts-ignore
[R.T, () => children]])(''))));
export { useMediaQuery } from 'react-responsive';
export { useScreenClass } from 'react-grid-system';
export default {
  Desktop,
  Tablet,
  Mobile,
  Default,
  ClearFix,
  Col,
  Container,
  Hidden,
  Row,
  ScreenClassProvider,
  Visible,
  setConfiguration
}; // export * from './grid'

export { Grid } from "./Grid";